import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconInfo = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.844 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M20.334,20.486 C18.082,22.752 15.087,24.000 11.900,24.000 C8.714,24.000 5.719,22.752 3.466,20.485 C-1.183,15.806 -1.183,8.193 3.466,3.515 C5.719,1.248 8.714,-0.000 11.900,-0.000 C15.087,-0.000 18.082,1.248 20.334,3.515 C22.588,5.781 23.829,8.795 23.829,12.000 C23.829,15.205 22.588,18.219 20.334,20.486 ZM18.929,4.929 C17.052,3.040 14.556,2.000 11.900,2.000 C9.245,2.000 6.749,3.040 4.872,4.929 C0.997,8.828 0.997,15.172 4.872,19.071 C6.749,20.960 9.245,22.000 11.900,22.000 C14.556,22.000 17.052,20.960 18.929,19.071 C20.807,17.183 21.841,14.671 21.841,12.000 C21.841,9.329 20.807,6.818 18.929,4.929 ZM13.889,19.000 L9.913,19.000 C9.365,19.000 8.919,18.552 8.919,18.000 C8.919,17.448 9.365,17.000 9.913,17.000 L10.907,17.000 L10.907,13.000 L9.913,13.000 C9.365,13.000 8.919,12.552 8.919,12.000 C8.919,11.448 9.365,11.000 9.913,11.000 L11.901,11.000 C12.450,11.000 12.895,11.448 12.895,12.000 L12.895,17.000 L13.889,17.000 C14.438,17.000 14.883,17.448 14.883,18.000 C14.883,18.552 14.438,19.000 13.889,19.000 ZM11.901,9.000 C10.805,9.000 9.913,8.102 9.913,6.999 C9.913,5.897 10.805,5.000 11.901,5.000 C12.998,5.000 13.889,5.897 13.889,6.999 C13.889,8.102 12.998,9.000 11.901,9.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconInfo.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
